import { useContext, useMemo } from 'react';
import ReactJson from 'react-json-view';
import { Box } from '@mui/system';
import useCommonStyles from '../../../../commonStyles';
import { Paper } from '@mui/material';

import { ConfigContext } from '../../../../Contexts/ConfigContext';
import { generateConfig, preProcessConfigBeforeDeFlatten } from '../../../../utilities/helpers';

const Overview = () => {
	const { rawConfig } = useContext(ConfigContext);
	const commonStyleClasses = useCommonStyles();

	const processedVideoSection = useMemo(() => {
		try {
			return generateConfig(preProcessConfigBeforeDeFlatten(rawConfig));
		} catch (err) {
			console.log(err);
		}
		return {};
	}, [rawConfig]);

	return (
		<Box className={commonStyleClasses.sectionOverview}>
			<Paper
				elevation={2}
				className={`${commonStyleClasses.sectionOverviewPaper} ${commonStyleClasses.mainPagePaperMarginStyle}`}
			>
				<ReactJson
					name={false}
					enableClipboard={true}
					displayDataTypes={false}
					src={processedVideoSection}
				/>
			</Paper>
		</Box>
	);
};

export default Overview;
